export const RESET_TABLE = "RESET_TABLE";
export const SET_TABLE_LOADING = "SET_TABLE_LOADING";
export const SET_TABLE_ROW_OVERLAY_POSITION = "SET_TABLE_ROW_OVERLAY_POSITION";

export const resetTable = payload => {
  return {
    type: RESET_TABLE,
    payload
  };
};

export const setTableLoading = payload => {
  return {
    type: SET_TABLE_LOADING,
    payload
  };
};

export const setTableRowOverlayPosition = payload => {
  return {
    type: SET_TABLE_ROW_OVERLAY_POSITION,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/table.actions.js